module.exports = __webpack_public_path__ + "img/1111.e5716352.png";